$(window).one('load', function(){
    $('.overlay').css('display', 'block');
    $('.overlay .close').on('click', function(){
        $('.overlay').css('display', 'none');
    })
});
